import creditoService from '@/servicios/credito'
import store from '@/store/index'

export const InsertaLogMixin = {
  data: () => ({
    consumiendoInsertaLog: false,
  }),
  methods: {
    // Metodos publicos
    InsertaLog(data = {}) {
      var leData
      this.$_InsertaLog_IniciaInsertaLog()
      // console.log(this.$_InsertaLog_GeneraDatos())
      try {
        leData = this.$_InsertaLog_GeneraDatos()
      } catch (e) {
        console.error('ERROR DEL LOG1')
      }
      try {
        creditoService
          .inserta_log(Object.assign(leData, data))
          .then((result) => {
            this.$_InsertaLog_TerminaInsertaLog()
            if (result.status != 200) {
              this.errorInsertaLog('ERROR AL INSERTAR LOG')
              return
            }
            const data = result.data
            if (data.Codigo != 200) {
              this.errorInsertaLog(data.Mensaje)
              return
            }
            this.postInsertaLog(data.Modelo)
          })
          .catch((err) => {
            this.$_InsertaLog_TerminaInsertaLog()
            console.error(err)
            this.errorInsertaLog('ERROR AL INSERTAR LOG')
          })
      } catch (e) {
        console.error('ERROR DEL LOG2', e)
      }
    },
    postInsertaLog() {},
    errorInsertaLog(mensaje) {
      console.error(mensaje)
    },

    // Metodos privados
    $_InsertaLog_IniciaInsertaLog() {
      this.consumiendoInsertaLog = true
    },
    $_InsertaLog_TerminaInsertaLog() {
      this.consumiendoInsertaLog = false
    },
    $_InsertaLog_GeneraDatos() {
      var localizacion_longitud = store.getters['credito/obtenerUbicacion'].lon
          ? store.getters['credito/obtenerUbicacion'].lon
          : '',
        localizacion_latitud = store.getters['credito/obtenerUbicacion'].lon
          ? store.getters['credito/obtenerUbicacion'].lon
          : ''
      return this.$_InsertaLog_GeneraRequest(
        localizacion_longitud,
        localizacion_latitud
      )
    },
    $_InsertaLog_GeneraRequest(localizacion_longitud, localizacion_latitud) {
      return {
        numero: store.getters['persona/obtenerPersona'].datosPersonales.numero,
        localizacion_longitud,
        localizacion_latitud,
        paso_proceso:
          store.getters['guia/obtenerInfoGuia'] == ''
            ? 0
            : store.getters['guia/obtenerInfoGuia'].pasoActual,
        //$parent.$options.name,
        titulo_pantalla:
          store.getters['guia/obtenerInfoGuia'].descripcionPaso == ''
            ? 'Principal'
            : store.getters['guia/obtenerInfoGuia'].descripcionPaso,
        folioDigital: store.getters['credito/obtenerFolioDigital'],
        id_subproducto:
          store.getters['credito/obtenerSolicitudDigitalRequest'].idSubproducto,
        navegador:
          navigator.userAgentData.brands.length > 0
            ? navigator.userAgentData.brands[0].brand
            : 'N/A',
        // dispositivo: navigator.userAgent
        //   .split('(')[1]
        //   .split(')')[0]
        //   .split(';')[2]
        //   .trim(),
        so: navigator.userAgent
          .split('(')[1]
          .split(')')[0]
          .split(';')[1]
          .trim(),
        movil: navigator.userAgentData.mobile ? 1 : 0,
        medio_de_contacto: store.getters['credito/obtenerMedioDeContacto']
          ? parseInt(store.getters['credito/obtenerMedioDeContacto'])
          : 0,
      }
    },
  },
}
